module.exports = __webpack_public_path__ + "static/media/earthCloudTexture.cbca641d.png";